import { render, staticRenderFns } from "./AuthenticateLogin.vue?vue&type=template&id=6879ddc3&scoped=true&"
import script from "./AuthenticateLogin.vue?vue&type=script&lang=js&"
export * from "./AuthenticateLogin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6879ddc3",
  null
  
)

export default component.exports